document.addEventListener("DOMContentLoaded", function () {
  const insuranceCheckbox = document.getElementById("insurance-toggle");
  const insurancePriceElement = document.getElementById("insurance-price");

  // Variant IDs
  const insuranceProductIdUnder74  = 41818468581473; // Under $74
  const insuranceProductId74Plus   = 41818468614241; // $74 to $125
  const insuranceProductId125Plus  = 41818468647009; // $125 to $200
  const insuranceProductId200Plus  = 41818468745313; // $200 to $350
  const insuranceProductId350Plus  = 41818468876385; // $350 to $500
  const insuranceProductId500Plus  = 41818468974689; // $500 to $650
  const insuranceProductId650Plus  = 41818469072993; // $650 to $800
  const insuranceProductId800Plus  = 41818469269601; // $800 to $1000
  const insuranceProductId1000Plus = 41818469466209; // Over $1000

  // Price mapping (for the label text)
  const insurancePrices = {
    41818468581473: 1.49,  // Under $74
    41818468614241: 1.99,  // $74 to $125
    41818468647009: 2.49,  // $125 to $200
    41818468745313: 3.99,  // $200 to $350
    41818468876385: 5.99,  // $350 to $500
    41818468974689: 7.49,  // $500 to $650
    41818469072993: 8.99,  // $650 to $800
    41818469269601: 11.99, // $800 to $1000
    41818469466209: 14.99  // Over $1000
  };

  function getInsuranceVariantIdForTotal(totalCents) {
    if (totalCents >= 100000) {
      return insuranceProductId1000Plus;
    } else if (totalCents >= 80000) {
      return insuranceProductId800Plus;
    } else if (totalCents >= 65000) {
      return insuranceProductId650Plus;
    } else if (totalCents >= 50000) {
      return insuranceProductId500Plus;
    } else if (totalCents >= 35000) {
      return insuranceProductId350Plus;
    } else if (totalCents >= 20000) {
      return insuranceProductId200Plus;
    } else if (totalCents >= 12500) {
      return insuranceProductId125Plus;
    } else if (totalCents >= 7400) {
      return insuranceProductId74Plus;
    } else {
      return insuranceProductIdUnder74;
    }
  }

  function updateDisplayedPrice(productId) {
    if (!insurancePriceElement) return;
    const price = insurancePrices[productId];
    if (price !== undefined) {
      insurancePriceElement.textContent = price.toFixed(2);
    }
  }

  function isInsuranceVariant(variantId) {
    return (
      variantId === insuranceProductIdUnder74  ||
      variantId === insuranceProductId74Plus   ||
      variantId === insuranceProductId125Plus  ||
      variantId === insuranceProductId200Plus  ||
      variantId === insuranceProductId350Plus  ||
      variantId === insuranceProductId500Plus  ||
      variantId === insuranceProductId650Plus  ||
      variantId === insuranceProductId800Plus  ||
      variantId === insuranceProductId1000Plus
    );
  }

  function lineProperties(item) {
    return item && item.properties && typeof item.properties === 'object'
      ? item.properties
      : {};
  }

  function hasSubscriptionBoxId(item) {
    return !!lineProperties(item)._SubscriptionBoxId;
  }

  function isSubscriptionGiftMessage(item) {
    return lineProperties(item)._SubscriptionGiftMessage === 'true';
  }

  function isSubscriptionOnlyCart(cart) {
    const items = cart && cart.items ? cart.items : [];
    const realItems = items.filter(item => {
      return !isInsuranceVariant(item.variant_id) && !isSubscriptionGiftMessage(item);
    });

    if (!realItems.length) return false;

    return realItems.every(item => hasSubscriptionBoxId(item));
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  async function removeInsuranceLines(cart) {
    const items = cart.items || [];
    const insuranceItems = items.filter(item => isInsuranceVariant(item.variant_id));

    for (const insuranceItem of insuranceItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: insuranceItem.key,
          quantity: 0
        })
      });
    }
  }

  async function addInsuranceLine(productId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: productId, quantity: 1 }]
      })
    });
  }

  async function ensureCorrectInsurance(cart, desiredProductId) {
    const items = cart.items || [];
    const insuranceItems = items.filter(item => isInsuranceVariant(item.variant_id));

    // No insurance yet → just add it
    if (insuranceItems.length === 0) {
      await addInsuranceLine(desiredProductId);
      return;
    }

    // If exactly one insurance line and it's already the right variant → nothing to do
    if (
      insuranceItems.length === 1 &&
      insuranceItems[0].variant_id === desiredProductId
    ) {
      return;
    }

    // Otherwise remove all existing insurance and add the correct one
    await removeInsuranceLines(cart);
    await addInsuranceLine(desiredProductId);
  }

  // 🔑 Called by the delivery modal before submitting the cart
  window.handleInsuranceForCheckout = async function () {
    const cart = await fetchCart();

    // No items in cart → nothing to do
    if (!cart.items || cart.items.length === 0) return;

    // ✅ NEW: if Checkout-Method is pickup, remove insurance but keep toggle/localStorage as-is
    const checkoutMethod =
      cart.attributes && cart.attributes['Checkout-Method'];

    if (checkoutMethod === 'pickup') {
      // Make sure NO delivery protection line item is present
      await removeInsuranceLines(cart);
      // Do NOT touch localStorage or checkbox state here
      return;
    }

    // Cookie box subscriptions do not use Delivery Protection when they are the only cart item.
    if (isSubscriptionOnlyCart(cart)) {
      await removeInsuranceLines(cart);
      return;
    }

    // If there's no checkbox at all, just skip insurance logic
    if (!insuranceCheckbox) return;

    const storedState = localStorage.getItem("insuranceToggleState");
    // Default ON if nothing stored, and respect the actual checkbox state
    const isToggleOn =
      (storedState === null || storedState === "on") &&
      insuranceCheckbox.checked !== false;

    if (!isToggleOn) {
      // Toggle is OFF → make sure insurance is removed
      await removeInsuranceLines(cart);
      return;
    }

    // Toggle is ON → ensure correct insurance variant is present
    const desiredProductId = getInsuranceVariantIdForTotal(cart.total_price);
    updateDisplayedPrice(desiredProductId);
    await ensureCorrectInsurance(cart, desiredProductId);
  };

  // 🔘 Basic checkbox + localStorage wiring (no cart mutations here)
  if (insuranceCheckbox) {
    const storedState = localStorage.getItem("insuranceToggleState");
    if (storedState === "off") {
      insuranceCheckbox.checked = false;
    } else {
      insuranceCheckbox.checked = true;
    }

    insuranceCheckbox.addEventListener("change", function () {
      localStorage.setItem(
        "insuranceToggleState",
        insuranceCheckbox.checked ? "on" : "off"
      );
    });
  }

  // --- 🧹 Auto-cleanup if insurance is only item or insurance + crisps only ---
  (async function autoCleanInsuranceOnlyCart() {
    try {
      const cart = await fetchCart();
      const items = cart.items || [];
      if (!items.length) return;

      const insuranceItems = items.filter(item => isInsuranceVariant(item.variant_id));

      if (isSubscriptionOnlyCart(cart)) {
        if (insuranceItems.length > 0) {
          await removeInsuranceLines(cart);
          window.location.reload();
        }
        return;
      }

      // 🔹 Filter out non-insurance AND non-crisps
      const nonInsuranceNonCrisps = items.filter(item => {
        const isInsurance = isInsuranceVariant(item.variant_id);
        const isCrisps = item.product_id === 7451545043041;
        return !isInsurance && !isCrisps;
      });

      // If there are ANY other kinds of products, leave cart alone
      if (nonInsuranceNonCrisps.length > 0) return;

      // Now we know: cart contains only insurance and/or crisps

      // If ANY insurance present, remove them
      await removeInsuranceLines(cart);

      // If the *only* non-insurance product was Cookie Crisps, also remove it
      const crispsItems = items.filter(item => item.product_id === 7451545043041);
      if (crispsItems.length > 0) {
        for (const crispsItem of crispsItems) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: crispsItem.key, quantity: 0 })
          });
        }
      }

      // Finally force a reload
      window.location.reload();
    } catch (err) {
      console.log("Error cleaning insurance-only cart:", err);
    }
  })();
});
